
import { Options } from "vue-class-component";
import Base from "../../../components/base/Base.vue";
import { computed } from "vue";
import LayoutService from "@/services/layout.service";
@Options({})
export default class Hall extends Base {
  public games = computed(() => this.store.getters.filterGame);
  created() {
    LayoutService.setGalleria({ visible: false });
  }
}
